/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfOAuthAuthoriseRequest } from '../models';
// @ts-ignore
import type { BfOAuthAuthoriseResponse } from '../models';
// @ts-ignore
import type { BfOAuthClientSummary } from '../models';
// @ts-ignore
import type { BfOAuthError } from '../models';
// @ts-ignore
import type { BfOAuthServerMetadata } from '../models';
// @ts-ignore
import type { BfOAuthTokenResponse } from '../models';
// @ts-ignore
import type { BfOAuthUserInfo } from '../models';
/**
 * OAuthApi - axios parameter creator
 */
export const OAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Issue a single-use authorisation code to the signed-in user for this request. The browser is then sent to `redirectTo`. Requires a session; access keys are refused.
         * @summary Approve sign-in
         * @param {BfOAuthAuthoriseRequest} bfOAuthAuthoriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authoriseApprove: async (bfOAuthAuthoriseRequest: BfOAuthAuthoriseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfOAuthAuthoriseRequest' is not null or undefined
            assertParamExists('authoriseApprove', 'bfOAuthAuthoriseRequest', bfOAuthAuthoriseRequest)
            const localVarPath = `/v1/oauth/authorise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfOAuthAuthoriseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin an OAuth 2.0 authorisation code request (RFC 6749 §4.1.1) with PKCE (RFC 7636). Redirects to the Bushfire.io sign-in page, or back to the client with an error. An unknown client or unregistered redirect_uri is reported here and never redirected.
         * @summary Start sign-in
         * @param {string} [responseType] Must be &#x60;code&#x60;
         * @param {string} [clientId] 
         * @param {string} [redirectUri] 
         * @param {string} [state] Opaque client value echoed back with the code, 1-512 characters
         * @param {string} [codeChallenge] BASE64URL(SHA256(code_verifier))
         * @param {string} [codeChallengeMethod] Must be &#x60;S256&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authoriseStart: async (responseType?: string, clientId?: string, redirectUri?: string, state?: string, codeChallenge?: string, codeChallengeMethod?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/oauth/authorise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (responseType !== undefined) {
                localVarQueryParameter['response_type'] = responseType;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirect_uri'] = redirectUri;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (codeChallenge !== undefined) {
                localVarQueryParameter['code_challenge'] = codeChallenge;
            }

            if (codeChallengeMethod !== undefined) {
                localVarQueryParameter['code_challenge_method'] = codeChallengeMethod;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The client a sign-in page is acting for, once its redirect_uri is confirmed registered.
         * @summary Describe a sign-in request
         * @param {string} clientId OAuth client id
         * @param {string} redirectUri 
         * @param {string | null} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSummary: async (clientId: string, redirectUri: string, state?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientSummary', 'clientId', clientId)
            // verify required parameter 'redirectUri' is not null or undefined
            assertParamExists('clientSummary', 'redirectUri', redirectUri)
            const localVarPath = `/v1/oauth/clients/{client_id}`
                .replace('{client_id}', encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirect_uri'] = redirectUri;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redeem an authorisation code for an access token (RFC 6749 §4.1.3), authenticating the client with HTTP Basic or form credentials. The access token is only valid at userinfo.
         * @summary Exchange code
         * @param {string | null} [clientId] Only when not using HTTP Basic client authentication
         * @param {string | null} [clientSecret] Only when not using HTTP Basic client authentication
         * @param {string | null} [code] 
         * @param {string | null} [codeVerifier] 
         * @param {string | null} [grantType] Must be &#x60;authorization_code&#x60;
         * @param {string | null} [redirectUri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeToken: async (clientId?: string | null, clientSecret?: string | null, code?: string | null, codeVerifier?: string | null, grantType?: string | null, redirectUri?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/oauth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (clientId !== undefined) { 
                localVarFormParams.set('client_id', clientId as any);
            }

            if (clientSecret !== undefined) { 
                localVarFormParams.set('client_secret', clientSecret as any);
            }

            if (code !== undefined) { 
                localVarFormParams.set('code', code as any);
            }

            if (codeVerifier !== undefined) { 
                localVarFormParams.set('code_verifier', codeVerifier as any);
            }

            if (grantType !== undefined) { 
                localVarFormParams.set('grant_type', grantType as any);
            }

            if (redirectUri !== undefined) { 
                localVarFormParams.set('redirect_uri', redirectUri as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoints and capabilities for Sign in with Bushfire.io (RFC 8414).
         * @summary Authorisation server metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverMetadata: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/.well-known/oauth-authorization-server`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The signed-in user behind a `Bearer` access token from the token endpoint, using OpenID Connect claim names. `sub` is the stable key for the user.
         * @summary User info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/oauth/userinfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OAuthApi - functional programming interface
 */
export const OAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Issue a single-use authorisation code to the signed-in user for this request. The browser is then sent to `redirectTo`. Requires a session; access keys are refused.
         * @summary Approve sign-in
         * @param {BfOAuthAuthoriseRequest} bfOAuthAuthoriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authoriseApprove(bfOAuthAuthoriseRequest: BfOAuthAuthoriseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOAuthAuthoriseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authoriseApprove(bfOAuthAuthoriseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.authoriseApprove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin an OAuth 2.0 authorisation code request (RFC 6749 §4.1.1) with PKCE (RFC 7636). Redirects to the Bushfire.io sign-in page, or back to the client with an error. An unknown client or unregistered redirect_uri is reported here and never redirected.
         * @summary Start sign-in
         * @param {string} [responseType] Must be &#x60;code&#x60;
         * @param {string} [clientId] 
         * @param {string} [redirectUri] 
         * @param {string} [state] Opaque client value echoed back with the code, 1-512 characters
         * @param {string} [codeChallenge] BASE64URL(SHA256(code_verifier))
         * @param {string} [codeChallengeMethod] Must be &#x60;S256&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authoriseStart(responseType?: string, clientId?: string, redirectUri?: string, state?: string, codeChallenge?: string, codeChallengeMethod?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authoriseStart(responseType, clientId, redirectUri, state, codeChallenge, codeChallengeMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.authoriseStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The client a sign-in page is acting for, once its redirect_uri is confirmed registered.
         * @summary Describe a sign-in request
         * @param {string} clientId OAuth client id
         * @param {string} redirectUri 
         * @param {string | null} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientSummary(clientId: string, redirectUri: string, state?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOAuthClientSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientSummary(clientId, redirectUri, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.clientSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redeem an authorisation code for an access token (RFC 6749 §4.1.3), authenticating the client with HTTP Basic or form credentials. The access token is only valid at userinfo.
         * @summary Exchange code
         * @param {string | null} [clientId] Only when not using HTTP Basic client authentication
         * @param {string | null} [clientSecret] Only when not using HTTP Basic client authentication
         * @param {string | null} [code] 
         * @param {string | null} [codeVerifier] 
         * @param {string | null} [grantType] Must be &#x60;authorization_code&#x60;
         * @param {string | null} [redirectUri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeToken(clientId?: string | null, clientSecret?: string | null, code?: string | null, codeVerifier?: string | null, grantType?: string | null, redirectUri?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOAuthTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeToken(clientId, clientSecret, code, codeVerifier, grantType, redirectUri, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.exchangeToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Endpoints and capabilities for Sign in with Bushfire.io (RFC 8414).
         * @summary Authorisation server metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serverMetadata(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOAuthServerMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serverMetadata(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.serverMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The signed-in user behind a `Bearer` access token from the token endpoint, using OpenID Connect claim names. `sub` is the stable key for the user.
         * @summary User info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userinfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOAuthUserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userinfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.userinfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OAuthApi - factory interface
 */
export const OAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OAuthApiFp(configuration)
    return {
        /**
         * Issue a single-use authorisation code to the signed-in user for this request. The browser is then sent to `redirectTo`. Requires a session; access keys are refused.
         * @summary Approve sign-in
         * @param {BfOAuthAuthoriseRequest} bfOAuthAuthoriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authoriseApprove(bfOAuthAuthoriseRequest: BfOAuthAuthoriseRequest, options?: RawAxiosRequestConfig): AxiosPromise<BfOAuthAuthoriseResponse> {
            return localVarFp.authoriseApprove(bfOAuthAuthoriseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin an OAuth 2.0 authorisation code request (RFC 6749 §4.1.1) with PKCE (RFC 7636). Redirects to the Bushfire.io sign-in page, or back to the client with an error. An unknown client or unregistered redirect_uri is reported here and never redirected.
         * @summary Start sign-in
         * @param {string} [responseType] Must be &#x60;code&#x60;
         * @param {string} [clientId] 
         * @param {string} [redirectUri] 
         * @param {string} [state] Opaque client value echoed back with the code, 1-512 characters
         * @param {string} [codeChallenge] BASE64URL(SHA256(code_verifier))
         * @param {string} [codeChallengeMethod] Must be &#x60;S256&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authoriseStart(responseType?: string, clientId?: string, redirectUri?: string, state?: string, codeChallenge?: string, codeChallengeMethod?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authoriseStart(responseType, clientId, redirectUri, state, codeChallenge, codeChallengeMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * The client a sign-in page is acting for, once its redirect_uri is confirmed registered.
         * @summary Describe a sign-in request
         * @param {string} clientId OAuth client id
         * @param {string} redirectUri 
         * @param {string | null} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSummary(clientId: string, redirectUri: string, state?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<BfOAuthClientSummary> {
            return localVarFp.clientSummary(clientId, redirectUri, state, options).then((request) => request(axios, basePath));
        },
        /**
         * Redeem an authorisation code for an access token (RFC 6749 §4.1.3), authenticating the client with HTTP Basic or form credentials. The access token is only valid at userinfo.
         * @summary Exchange code
         * @param {string | null} [clientId] Only when not using HTTP Basic client authentication
         * @param {string | null} [clientSecret] Only when not using HTTP Basic client authentication
         * @param {string | null} [code] 
         * @param {string | null} [codeVerifier] 
         * @param {string | null} [grantType] Must be &#x60;authorization_code&#x60;
         * @param {string | null} [redirectUri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeToken(clientId?: string | null, clientSecret?: string | null, code?: string | null, codeVerifier?: string | null, grantType?: string | null, redirectUri?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<BfOAuthTokenResponse> {
            return localVarFp.exchangeToken(clientId, clientSecret, code, codeVerifier, grantType, redirectUri, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoints and capabilities for Sign in with Bushfire.io (RFC 8414).
         * @summary Authorisation server metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverMetadata(options?: RawAxiosRequestConfig): AxiosPromise<BfOAuthServerMetadata> {
            return localVarFp.serverMetadata(options).then((request) => request(axios, basePath));
        },
        /**
         * The signed-in user behind a `Bearer` access token from the token endpoint, using OpenID Connect claim names. `sub` is the stable key for the user.
         * @summary User info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfo(options?: RawAxiosRequestConfig): AxiosPromise<BfOAuthUserInfo> {
            return localVarFp.userinfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OAuthApi - object-oriented interface
 */
export class OAuthApi extends BaseAPI {
    /**
     * Issue a single-use authorisation code to the signed-in user for this request. The browser is then sent to `redirectTo`. Requires a session; access keys are refused.
     * @summary Approve sign-in
     * @param {BfOAuthAuthoriseRequest} bfOAuthAuthoriseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authoriseApprove(bfOAuthAuthoriseRequest: BfOAuthAuthoriseRequest, options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).authoriseApprove(bfOAuthAuthoriseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin an OAuth 2.0 authorisation code request (RFC 6749 §4.1.1) with PKCE (RFC 7636). Redirects to the Bushfire.io sign-in page, or back to the client with an error. An unknown client or unregistered redirect_uri is reported here and never redirected.
     * @summary Start sign-in
     * @param {string} [responseType] Must be &#x60;code&#x60;
     * @param {string} [clientId] 
     * @param {string} [redirectUri] 
     * @param {string} [state] Opaque client value echoed back with the code, 1-512 characters
     * @param {string} [codeChallenge] BASE64URL(SHA256(code_verifier))
     * @param {string} [codeChallengeMethod] Must be &#x60;S256&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authoriseStart(responseType?: string, clientId?: string, redirectUri?: string, state?: string, codeChallenge?: string, codeChallengeMethod?: string, options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).authoriseStart(responseType, clientId, redirectUri, state, codeChallenge, codeChallengeMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The client a sign-in page is acting for, once its redirect_uri is confirmed registered.
     * @summary Describe a sign-in request
     * @param {string} clientId OAuth client id
     * @param {string} redirectUri 
     * @param {string | null} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public clientSummary(clientId: string, redirectUri: string, state?: string | null, options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).clientSummary(clientId, redirectUri, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redeem an authorisation code for an access token (RFC 6749 §4.1.3), authenticating the client with HTTP Basic or form credentials. The access token is only valid at userinfo.
     * @summary Exchange code
     * @param {string | null} [clientId] Only when not using HTTP Basic client authentication
     * @param {string | null} [clientSecret] Only when not using HTTP Basic client authentication
     * @param {string | null} [code] 
     * @param {string | null} [codeVerifier] 
     * @param {string | null} [grantType] Must be &#x60;authorization_code&#x60;
     * @param {string | null} [redirectUri] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exchangeToken(clientId?: string | null, clientSecret?: string | null, code?: string | null, codeVerifier?: string | null, grantType?: string | null, redirectUri?: string | null, options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).exchangeToken(clientId, clientSecret, code, codeVerifier, grantType, redirectUri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoints and capabilities for Sign in with Bushfire.io (RFC 8414).
     * @summary Authorisation server metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public serverMetadata(options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).serverMetadata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The signed-in user behind a `Bearer` access token from the token endpoint, using OpenID Connect claim names. `sub` is the stable key for the user.
     * @summary User info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userinfo(options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).userinfo(options).then((request) => request(this.axios, this.basePath));
    }
}

